class InvalidArgumentError extends Error { }

export {
  InvalidArgumentError
}